import { render, staticRenderFns } from "./DynamicFieldsDialog.vue?vue&type=template&id=0738b57a&scoped=true&"
import script from "./DynamicFieldsDialog.vue?vue&type=script&lang=js&"
export * from "./DynamicFieldsDialog.vue?vue&type=script&lang=js&"
import style0 from "./DynamicFieldsDialog.vue?vue&type=style&index=0&id=0738b57a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0738b57a",
  null
  
)

export default component.exports